@if (shouldOnboardingBeShown()) {
  <div class="onboarding-card mb-20">
    <header class="onboarding-card__header">
      <div class="onboarding-header__progress">
        <span class="progress-indicator">
          <svg class="progress-indicator__ring" viewBox="0 0 56 56" aria-hidden="true">
            <circle class="ring__track" cx="28" cy="28" r="26"></circle>
            <circle class="ring__value" cx="28" cy="28" r="26" [attr.stroke-dasharray]="progressDashArray()"></circle>
          </svg>
          <span class="progress-indicator__label">{{ progressLabel() }}</span>
        </span>
        <div class="onboarding-header__content">
          <h3 class="onboarding-header__title">Account Setup</h3>
          <p class="onboarding-header__subtitle">Finish your setup in order to get access to platform.</p>
        </div>
      </div>
    </header>

    <section class="onboarding-card__body">
      <ul class="onboarding-steps">
        @for (step of steps(); track step.title; let idx = $index) {
          <app-onboarding-step [step]="step" [index]="idx" (stepSelect)="onStepSelect($event)" />
        }
      </ul>
    </section>
  </div>

  <hr class="neutral-n4" />
}

<!-- for new users the logic will remain the same as before, we still show a banner with billing info & clickwrap info -->
@if (shouldShowBillingRestrictionsForNewMainAccount()) {
  <div class="d-flex justify-content-between align-items-center alert alert-warning">
    <div class="d-flex justify-content-start align-items-center gap-10">
      <span class="icon-warning"></span>
      <div class="impersonate-container">
        {{ billingUnavailableMessage() }}The agreement between TelQ and your company isn't accepted yet. Please Review &amp; Accept the agreement in
        <a class="text-warning-w3 fw-bold text-decoration-underline" href="#/legal-documents"> Legal Documents </a> section.
      </div>
    </div>
  </div>
}

<!-- company details changed: agreement must wait until the updated details are re-verified -->
@if (shouldShowCompanyDetailsUnderReviewForMainAccount()) {
  <div class="d-flex justify-content-between align-items-center alert alert-warning">
    <div class="d-flex justify-content-start align-items-center gap-10">
      <span class="icon-warning"></span>
      <div class="impersonate-container">
        {{ billingUnavailableMessage() }}Your updated company details are under review. Once they're approved, the MSA &amp; DPA will become available
        for you to review and sign.
      </div>
    </div>
  </div>
}

<!-- for new / old subaccounts the logic will remain the same as before, we still show a banner with billing info & clickwrap info for company -->
@if (shouldShowBillingRestrictionsForSubAccounts()) {
  <div class="d-flex justify-content-between align-items-center alert alert-warning">
    <div class="d-flex justify-content-start align-items-center gap-10">
      <span class="icon-warning"></span>
      <div class="impersonate-container">
        Billing and top-up is currently unavailable. The agreement between TelQ and your company isn't accepted yet. Please contact your account
        owner.
      </div>
    </div>
  </div>
}

<!-- for old users we will show a new small stepper -->
@if (shouldShowFinishStepsForExistingMainAccounts()) {
  <div class="onboarding-card mb-20">
    <header class="onboarding-card__header">
      <div class="d-flex align-items-center gap-10">
        <span class="icon-warning fs-2 text-primary-p4"></span>
        <div class="onboarding-header__content">
          <h3 class="onboarding-header__title">Action Required</h3>
          <p class="onboarding-header__subtitle">A quick step or two to keep using TelQ without interruption.</p>
        </div>
      </div>
    </header>

    <section class="onboarding-card__body">
      <ul class="onboarding-steps">
        @for (step of stepsForExistingUsers(); track step.title) {
          <app-onboarding-step [step]="step" (stepSelect)="onStepSelect($event)" />
        }
      </ul>
    </section>
  </div>
}
